// removed by extract-text-webpack-plugin
module.exports = {"brands":"_-VEom916p","brands-content":"_2MMS7GP2S","title":"_3gqNQoBkX _1yJuXbiru _2NhPjnbc3 _13qojEuKg _1BE2U7F8v _1C-lRJLgc _1gaUFCwDT","text":"_1sV2BmVRI _1yJuXbiru _1FTxuUfut _1yThnDgzj _1BE2U7F8v _1C-lRJLgc hxreTUKKY _1wvTIgrJh","list":"_3H6COtR2p _17qxy1jyE FVmsZrNVi _1qWQbQfK8 _2OWJoa0B_ _2OFVW-wzu _1-ov2DQLe YXYmy67R7 _2HOZDFp6P _2_tabFk6j _34skhd3lM _1C-lRJLgc eQmKwyjT2 hxreTUKKY _76colo4FN","list__item":"_2H7YpIGSU _17qxy1jyE _34YKmqAjT _1II0OCq4x _3l91ZaNqh pzmz6Pfas _3BpZ2vBlT IUmssOTRK _3Lj_37o7k","list__img":"_2sAmRu2He _2l0xl0HVf _1rORQmTV0 _2SKVr1fPM"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/ticketing-page/brands/brands.css
 ** module id = 2197
 ** module chunks = 0
 **/